const nameData = "articulos_listaprecios";

/**
 * Obtiene los artículos de una lista de precios
 * Combina datos de la API con el array temporal
 */
export const fetchEntityData = async (
  getEntityPanelData,
  searchArtId,
  numPagina,
  filas,
  lpid,           // ID de la lista de precios
  setListaItems,
  setTotalItems,
  arrayDetalle
) => {
  try {
    let listaArticulos = [];
    let totalApiItems = 0;

    // Obtener datos de la API si existe lpid
    if (lpid) {
      const data = await getEntityPanelData(lpid, searchArtId, numPagina, filas);
      if (data) {
        listaArticulos = data.products || data.articulos_listaprecios || [];
        totalApiItems = data.pagination?.totalItems || 0;
      }
    }

    const totalArrayItems = arrayDetalle?.length || 0;
    const totalItems = totalApiItems + totalArrayItems;
    const totalPages = Math.ceil(totalItems / filas) || 1;

    // Combinar API + arrayDetalle
    const combinedList = [...listaArticulos, ...arrayDetalle];

    // Aplicar paginación
    const start = (numPagina - 1) * filas;
    const end = start + filas;
    const paginatedList = combinedList.slice(start, end);

    // Actualizar estado
    setListaItems(paginatedList);
    setTotalItems(totalItems);

    return { totalPages, totalItems };
  } catch (error) {
    console.error(`Error al cargar ${nameData}:`, error);
    throw error;
  }
};

/**
 * Elimina un artículo de la lista de precios
 * Usa clave compuesta (art_id, lp_id)
 */
export const deleteItem = async (
  deleteEntityData,
  selectedItem,      // art_id
  lpid,              // lp_id
  arrayDetalle,
  removeItem,
  getListaDetByIdData
) => {
  try {
    // Buscar en array temporal primero
    const detalleEnArray = arrayDetalle.find(
      (item) => item.art_id === selectedItem || item.id === selectedItem
    );

    if (detalleEnArray) {
      // Eliminar del array temporal
      removeItem(detalleEnArray.id || detalleEnArray.art_id);
    } else {
      // Eliminar de la BD usando clave compuesta
      const detalle = await getListaDetByIdData(selectedItem, lpid);
      if (detalle) {
        await deleteEntityData(selectedItem, lpid);
      } else {
        console.error(`No se encontraron datos para art_id: ${selectedItem}, lp_id: ${lpid}`);
      }
    }
  } catch (error) {
    console.error("Error durante la eliminación:", error);
    throw error;
  }
};

/**
 * Guarda múltiples artículos en una lista de precios
 * (para agregar con filtros)
 */
export const saveMultipleItems = async (
  postEntityData,
  items,
  lpid
) => {
  try {
    const results = [];
    const errors = [];

    for (const item of items) {
      try {
        const dataToSave = {
          art_id: item.art_id,
          lp_id: lpid,
          alp_art_npreciocosto: item.alp_art_npreciocosto || 0,
          alp_art_nprecioventa: item.alp_art_nprecioventa || 0,
          alp_art_npreciomayorista: item.alp_art_npreciomayorista || 0,
          alp_porclista: item.alp_porclista || 0,
          alp_margen: item.alp_margen || 0,
          alp_tipo_actualizacion: item.alp_tipo_actualizacion || 0,
          alp_imp_fijo: item.alp_imp_fijo || 0,
          alp_show_web: item.alp_show_web || 0,
          alp_show_app: item.alp_show_app || 0,
        };

        const result = await postEntityData(dataToSave);
        results.push(result);
      } catch (err) {
        console.error(`Error guardando art_id ${item.art_id}:`, err);
        errors.push({ art_id: item.art_id, error: err.message });
      }
    }

    return { results, errors, total: items.length, saved: results.length };
  } catch (error) {
    console.error("Error al guardar múltiples items:", error);
    throw error;
  }
};
